import Image from 'next/image'

import styles from './label.module.scss'

type CommunityLabelProps = {
  count?: number
  label: string
  icon: string
  isLoading?: boolean
}
export default function Label({ count, label, icon, isLoading }: CommunityLabelProps): JSX.Element {
  return (
    <div className={styles.label}>
      <Image src={icon} alt={`${label}-icon`} className={styles.icon} />
      <p>
        <span className={isLoading ? styles.loading : ''}>{count}</span> {label}
      </p>
    </div>
  )
}
